import React, { useContext } from "react";
import UndrawOnline from "../assets/undraw_online_test_re_kyfx.svg";
import { Link } from "react-router-dom";
import { AuthContext } from "../../AuthContext";
const Test = () => {
  const authContext = useContext(AuthContext);
  return (
    <div
      id="test"
      className="bgHome pt-5 border-bottom border-opacity-25 border-secondary border-3 shadow"
    >
      <div className="container ">
        <div className="row  d-flex justify-content-center  align-items-center ">
          <div className="col-md-7 d-flex justify-content-center flex-column align-items-center pt-5 pt-lg-0 ">
            <h2 className="pb-1 fw-bold after position-relative">Tests</h2>
            <div className="w-75 bg-light border-bottom border-opacity-25 border-secondary border-3 shadow rounded-4 p-3 mt-4 ">
              <p>
                A variety of evaluation methods may be used during the
                assessment process. This can include clinical interviews,
                structured or semi-structured questionnaires or inventories,
                psychological testing, and observation. The specific methods
                used depend on the nature of the individual's concerns and the
                expertise of the mental health professional.
              </p>
            </div>
            <button className="px-3 py-2 mt-5 mb-4 btnCustom rounded-5">
              {" "}
              {authContext.auth && authContext.auth.user ? (
                <Link style={{ color: "#eee" }} className="nav-link " to="test">
                  Test
                </Link>
              ) : (
                <Link
                  style={{ color: "#eee" }}
                  className="nav-link "
                  to="/welcom2"
                >
                  Test
                </Link>
              )}
            </button>
          </div>
          <div className="col-md-5 col-8 d-flex justify-content-center  align-items-center  pt-3  ">
            <img className="w-100 " src={UndrawOnline} alt="online" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Test;
